import React from "react";
import Language from "../../lib/Language";
import { TComponent } from "../../types/utils";

type TTopLeftProps = {
    /** Originates from ListCalendar's cloneElement injection; may be absent. */
    topLeft?: React.JSX.Element;
    contents: React.JSX.Element | null;
};

const TopLeft: TComponent<TTopLeftProps> = ({ topLeft, contents }) => (
    <div className="listTopLine">
        {topLeft}{" "}
        <span style={{ fontWeight: "bold", paddingLeft: "10px" }} className="summaryLabel">
            {Language.get("nc_activity_manager")}
        </span>
        {contents}
    </div>
);

export default TopLeft;
